const agol_token = "AAPTxy8BH1VEsoebNVZXo8HurJl4KwLyt2eBDrf4V3mKBWjbVlucSl04jdq383qKDdhTyMTHmPYNkWh9iwRqfIksvDd0luIQeN5bdB2rLIrgqO_mrssAm1mNmHqlDBp2tWLiMVE74U2cWUhkrwRZ2vOyNkmikiicbM2XP0ZYwrO7JNH_a-nUVxMCk6gEU2C4U-gAXmz7GOzyoez0M0dSY9tOra8JWm0wmtXR8AC7jmS6TIA.AT1_bwjhWyey";

export default agol_token;